export const formatTimeRemaining = (msRemaining: number) => {
    if (msRemaining <= 0) return "Expired"
    const secondsRemaining = msRemaining / 1000
    const mins = Math.floor(secondsRemaining / 60)
    const seconds = Math.floor(secondsRemaining % 60)
    if (mins < 1) return `${seconds}s`
    if (mins < 15) return `${mins}m ${seconds}s`
    if (mins < 60) return `${mins}m`
    const hours = Math.floor(mins / 60)
    const minutes = mins % 60
    return `${hours}h ${minutes}m`
}
